import company from "./company.component";
import companyUrls from "./company.urls";
import CompanyTransforms from "./company.transforms";

const companyModule = angular
  .module("app.components.company", [])
  .component("companyPage", company)
  .service("CompanyTransforms", CompanyTransforms)
  .config(companyUrls);

export default companyModule;



// WEBPACK FOOTER //
// ./src/pages/company/company.module.js